import { authService } from './auth.service';
import { API_BASE_URL, API_ENDPOINTS } from '../config/api';
import type { ApiResponse, JobResultsResponse, Job } from '../types/api';

class ResultsService {
  /**
   * Get analyzed articles for a job
   */
  async getJobResults(
    jobId: string,
    minScore?: number,
    limit = 100,
    offset = 0
  ): Promise<JobResultsResponse> {
    const params = new URLSearchParams({
      limit: limit.toString(),
      offset: offset.toString(),
      ...(minScore !== undefined && { min_score: minScore.toString() })
    });

    const response = await fetch(
      `${API_BASE_URL}${API_ENDPOINTS.JOB_RESULTS(jobId)}?${params}`,
      { headers: authService.getAuthHeaders() }
    );

    const data: ApiResponse<JobResultsResponse> = await response.json();

    if (!data.success || !data.data) {
      throw new Error(data.error || 'Failed to get results');
    }

    return data.data;
  }

  /**
   * Get job details (for results page header)
   */
  async getJob(jobId: string): Promise<Job> {
    const response = await fetch(`${API_BASE_URL}${API_ENDPOINTS.JOB_BY_ID(jobId)}`, {
      headers: authService.getAuthHeaders()
    });

    const data: ApiResponse<{ job: Job }> = await response.json();

    if (!data.success || !data.data) {
      throw new Error(data.error || 'Failed to get job');
    }

    return data.data.job;
  }
}

export const resultsService = new ResultsService();
